import { Phone } from "lucide-react";
import type { FC } from "react";
import { AdvisorCard } from "web_myplann/Advisor/Components/AdvisorCard";
import { AdvisorCardSkeleton } from "web_myplann/Advisor/Components/AdvisorCardSkeleton";
import { mapAdvisorAssistantCardProps } from "web_myplann/Advisor/Mappers/mapAdvisorAssistantCardProps";
import type { AgentDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CenteredEmptyState } from "web_myplann/Shared/Components/CenteredEmptyState";

const R = Resources.Advisor;

type Props = {
	isLoading: boolean;
	detail?: AgentDetailResponseDTO | null;
	advisorName?: string;
	onBackToAdvisor: () => void;
};

export const AdvisorAssistantPageBody: FC<Props> = ({
	isLoading,
	detail,
	advisorName,
	onBackToAdvisor,
}) => {
	const { t } = useResource();

	return (
		<>
			{isLoading && <AdvisorCardSkeleton />}
			{!isLoading && !detail && (
				<CenteredEmptyState
					icon={Phone}
					title={t(R.assistantEmptyTitle)}
					description={t(R.assistantEmptyDescription)}
					actionLabel={t(R.backToAdvisor)}
					onAction={onBackToAdvisor}
				/>
			)}
			{!isLoading && detail && (
				<AdvisorCard
					key={detail.uid}
					{...mapAdvisorAssistantCardProps(detail, t(R.assistant))}
					avatarMuted
					worksWithName={advisorName}
					introBeforeActions
				/>
			)}
		</>
	);
};
